import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    $(this.inputTarget).autocomplete({
      minChars: 1,
      autoSelectFirst: true,
      triggerSelectOnValidInput: false,
      formatResult: function(suggestion) {
        return `<div><strong>${suggestion.value}</strong> ${suggestion.category}</div>`
      },
      lookup: function(query, done) {
        var items = []
        Object.keys(gon.technologies).forEach(function(i) {
          if (gon.technologies[i].name.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
            items.push({
              value: gon.technologies[i].name,
              category: gon.technologies[i].category,
              slug: gon.technologies[i].slug
            })
          }
        })
        done({suggestions: items})
      },
      onSelect: function (suggestion) {
        Turbo.visit(`/technologies/${suggestion.slug}`)
      }
    })
  }
}
